// extracted by mini-css-extract-plugin
export default {"disconnectLabel":"ActionConnections_disconnectLabel__bwBvE"};